export const environment = {
  production: false,
  oktaConfig: {
    clientId: '0oa2gp4qgpuQX2HZU0h8',
    issuer: 'https://myappstest.halliburton.com/oauth2/aus2g5leuppRFvSWO0h8',
    redirectUri: 'https://qa.adr.ienergy.halliburton.com/login/callback',
    postLogoutRedirectUri: 'https://qa.adr.ienergy.halliburton.com',
    scopes: ['address', 'email', 'offline_access', 'openid', 'phone', 'profile'],
    pkce: true,
    testing: {
      disableHttpsCheck: true,
    },
  },
  // MSAL is disabled in QA – Okta is used instead.
  // Shape must remain consistent with dev environments for TypeScript compatibility.
  msalConfig: {
    auth: {
      clientId: '',
      authority: 'https://login.microsoftonline.com/common',
      redirectUri: '/',
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: 'memoryStorage' as const,
      storeAuthStateInCookie: false,
    },
  },
  msalScopeUri: '',
};
